import { useEffect, useMemo } from 'react'
import { useAtom } from 'jotai'
import { useOutletContext } from 'react-router-dom'
import { purchaseTypeAtom } from '@!/atoms/paymentAtom'
import { Stack, HStack, Center, Box, Text, Grid, Divider, Image } from '@chakra-ui/react'
import { SecondaryButton } from '@!/components/Button'
import { getDevice, buildAssetUrlString } from '@!/Util'
import monthlyCourseMaxPointBackBanner from '@images/monthly_course_max_point_back_banner.webp'

export const MonthlyCourses = () => {
  const { monthlyCourses, onMonthlyCourseSelect } = useOutletContext()
  const [, setPurchaseType] = useAtom(purchaseTypeAtom)
  const device = useMemo(() => getDevice(), [])

  useEffect(() => {
    setPurchaseType('monthly')
  }, [])

  return (
    <Stack px={4} fontFamily="Hiragino Sans">
      {device === 'sp' && <Image alt="月額コースなら年間最大24,000円分ポイントバック！" src={buildAssetUrlString(monthlyCourseMaxPointBackBanner)} pb={2} />}
      {monthlyCourses.map((course) => (
        <Stack key={course.name} bgColor="bg.secondary" borderColor="divider.light" borderWidth={1} borderRadius={4} px={4} pt={3} pb={2} w="full">
          <Center>
            <Text fontWeight="semibold" fontSize="xs">
              月額
              <Text as="span" fontWeight="extrabold" fontSize="2xl" px={1}>
                {course.amount.toLocaleString()}
              </Text>
              円(税込)
            </Text>
          </Center>

          <Divider />

          <HStack justifyContent="space-between">
            <Box fontSize="xs">
              <Grid templateColumns="100px 1fr" rowGap={1}>
                <Text fontWeight="semibold">付与コイン</Text>
                <Text>{course.coin_count.toLocaleString()}</Text>

                <Text fontWeight="semibold">登録ボーナス</Text>
                <Text>
                  {`${course.reg_bonus_point_count.toLocaleString()}pt`} ({course.reg_bonus_rate}%)
                </Text>

                <Text fontWeight="semibold">継続ボーナス</Text>
                <Text>
                  {`${course.cont_bonus_point_count.toLocaleString()}pt`} ({course.cont_bonus_rate}%)
                </Text>
              </Grid>
            </Box>
            {(() => {
              const isRegistered = course.is_registered
              const isCancelReserved = course.is_cancel_reserved
              return (
                <SecondaryButton width="88px" height="37px" isDisabled={isRegistered || isCancelReserved} onClick={() => onMonthlyCourseSelect(course)}>
                  {isRegistered ? '登録中' : '登録する'}
                </SecondaryButton>
              )
            })()}
          </HStack>
        </Stack>
      ))}
    </Stack>
  )
}
